import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Iconc from 'components/Iconc';
import {SCROLL_TIME, DIRECTION} from 'common/js/params';
import dshStore from '../request/model';
import {getEnvironment} from '../request/dao';
import './index.styl';

const clzpre = 'dsh-environment';

@observer
class Environment extends Component{
    animateId;

    start = 0;

    scrollpx = 0;

    constructor(props){
        super(props);
        this.list = React.createRef();
        getEnvironment();
    }
    componentDidMount(){
        this.animateId = requestAnimationFrame(this.autoScroll);
    }

    componentWillUnmount(){
        cancelAnimationFrame(this.animateId);
    }

    autoScroll = (time) => {
        if (!this.list.current) {
            return;
        }
        if (this.list.current.scrollHeight <= this.list.current.clientHeight + 20) {
            this.animateId = requestAnimationFrame(this.autoScroll);
            return;
        }
        if (!this.start) {
            this.start = time;
        }
        const diff = time - this.start;
        this.start = time;

        this.scrollpx += diff / SCROLL_TIME;
        const remainH = this.list.current.scrollHeight - this.list.current.clientHeight + 10;
        if (this.scrollpx >= remainH) {
            this.scrollpx = 0;
            // this.list.current.scrollTo(0, 0);
            this.list.current.scrollTop = 0;
        } else {
            // this.list.current.scrollTo(0, this.scrollpx);
            this.list.current.scrollTop = this.scrollpx;
        }
        this.animateId = requestAnimationFrame(this.autoScroll);
    }

    getDom = () => {
        const {environments} = this.props.dshStore;
        return environments.map((env) => (
            <li className={`${clzpre}-item`} key={env.name}>
                <h4>
                    <Iconc type='huabanfuben' />
                    {env.name}
                </h4>
                {env.children.map((item, i) => {
                    if(item.key === 'wind_direction') {
                        return (
                            <p key={i}>{item.name}: {DIRECTION[item.value] || '--'}</p>
                        );
                    } else {
                        return (<p key={i}>{item.name}: {item.value}</p>);
                    }
                })}
            </li>
        ));
    }

    render(){
        return <div className={`${clzpre} dsh-box`}>
            <h3>环境参数信息</h3>
            <ul ref={this.list}>
                {this.getDom()}
            </ul>
        </div>;
    }
}

export default props => <Environment {...props} dshStore={dshStore} />;
